import React from 'react';
import Time_Table from './Time_Table';
import '../../CommonCSS/SocietyCSS.css';

const Time_TableApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5> TimeTable</h5>
          </div>
        </div>
        <Time_Table />
      </div>
    </div >
  );
};

export default Time_TableApp;
